import {Entry} from "../../../../core/entities/entry/domain/model/entry.model";
import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export type EntriesAction = 'added' | 'updated' | 'removed';

export class EntriesChangedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor(
    public readonly entries: Entry[],
    public readonly action: EntriesAction
  ) {
  }
}
